<div class="landing-dog-tile-container">
  <div class="d-flex justify-content-between align-items-center">
    <div
      class="
        d-flex
        flex-row
        align-items-center
        landing-dog-tile-title-container
      "
    >
      <img
        class="pet-avatar"
        src="{{ petImage }}"
        alt="Profile Picture"
        height="60"
      />
      <header class="oswald primary dog-name">{{ petName }}</header>
    </div>
    <div
      class="link oswald"
      (click)="navigateToDogProfile()"
      (keyup.enter)="navigateToDogProfile()"
      tabindex="0"
    >
      View/Edit
    </div>
  </div>
  <div class="landing-dog-tile-content-container">
    <div
      *ngIf="upcomingBookings.length > 0"
      class="lato bold status-message-title"
    >
      Upcoming Reservation
    </div>
    <div *ngFor="let upcomingEvent of upcomingBookings">
      <div class="lato status-message-body">
        {{ getBookingTitle(upcomingEvent) }}:
        {{ upcomingEvent.startDate | date }}
        <span *ngIf="upcomingEvent?.startDate != upcomingEvent?.endDate">
          - {{ upcomingEvent.endDate | date }}</span
        >
      </div>
    </div>
    <div
      *ngIf="
        petStatusData.statusId === PetStatusType.PASSED_INTERVIEW &&
        petStatusData.upcomingBookings.length === 0 &&
        petStatusData.waitlistBookings.length === 0 &&
        petStatusData.reservationRequests.length === 0
      "
    >
      <span class="lato bold">No Upcoming Reservations</span>
      <app-arrow-link
        class="float-right"
        text="Book"
        [useLato]="true"
        (handleClick)="navigateToReservationRequest()"
      ></app-arrow-link>
    </div>
    <div *ngIf="petStatusData.statusId === PetStatusType.PENDING_INTERVIEW && upcomingInterviews.length === 0">
      <span class="lato bold status-message-title is-warning"
        >Interview Required</span
      >
      <div
        *ngIf="
          !petStatusData.weight ||
            !petStatusData.breeds ||
            petStatusData.breeds.length === 0;
          else showIR
        "
      >
        <div
          *ngIf="
            !petStatusData.weight &&
              (!petStatusData.breeds || petStatusData.breeds.length == 0);
            else singleError
          "
        >
          <span class="lato status-message-body"
            >Pet Weight and Breed are missing</span
          >
        </div>
        <ng-template #singleError>
          <span *ngIf="!petStatusData.weight" class="lato status-message-body"
            >Pet Weight is missing</span
          >
          <span
            *ngIf="!petStatusData.breeds || petStatusData.breeds.length == 0"
            class="lato status-message-body"
          >
            Pet Breed is missing
          </span>
        </ng-template>
      </div>
      <ng-template #showIR>
        <app-arrow-link
          class="float-right"
          text="Book"
          [useLato]="true"
          (handleClick)="navigateToInterviewRequest()"
        ></app-arrow-link>
      </ng-template>
    </div>
    <div *ngIf="showVaccineSection()">
      <div class="section-divider"></div>

      <span class="lato bold status-message-title is-warning"
        >Vaccination(s)</span
      >
      <div *ngFor="let vaccination of petStatusData.vaccines">
        <div *ngIf="vaccination.vaccinationExpirationState > 0">
          <div
            class="lato status-message-body mb-1"
            [ngClass]="{ 'expired-row': vaccination.vaccinationExpirationState === vaccineStatusEnum.Expired }"
          >
            <div>{{ vaccination.vaccine.name + ": " }}</div>
            <div>
              {{ vaccination.expiresOn | date }}
              <span
                class="status"
                [ngClass]="{
                  'expiring-soon': vaccination.vaccinationExpirationState === vaccineStatusEnum.ExpiringSoon,
                  expired: vaccination.vaccinationExpirationState === vaccineStatusEnum.Expired
                }"
              >
                <span *ngIf="vaccination.vaccinationExpirationState === vaccineStatusEnum.ExpiringSoon"
                  >Expiring&nbsp;Soon</span
                >
                <span *ngIf="vaccination.vaccinationExpirationState === vaccineStatusEnum.Expired"
                  >Expired</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
